var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.allComments),function(comment){return _c('li',{key:comment.time},[_c('i',[_vm._v(" "+_vm._s(comment.author)+" commented: ")]),_c('span',[_c('b',[_vm._v(" "+_vm._s(comment.description)+" ")])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }